<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Search Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-2">
          <v-col cols="12" sm="6" md="6">
            <v-checkbox v-model="model.major" class="mx-1 mt-0" label="Major search" hide-details/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-checkbox v-model="model.minor" class="mx-1 mt-0" label="Minor search" hide-details/>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-checkbox v-model="model.skipLocked" class="mx-1 mt-0" label="Skip Locked" hide-details/>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <r-item-table :items.sync="model.sources" title="Sources"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SearchConfig} from "@/modules/redactor/models/search/SearchConfig";
import RItemTable from "@/modules/redactor/views/item/r-item-table";

export default {
  name: "r-search-config",
  components: {RItemTable},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new SearchConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new SearchConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>